(function () {
  function mpTrack(name, props) {
    try {
      if (window.arthcartMixpanel && typeof window.arthcartMixpanel.track === 'function') {
        window.arthcartMixpanel.track(name, props || {});
      } else if (window.mixpanel && typeof mixpanel.track === 'function') {
        mixpanel.track(name, props || {});
      }
    } catch (e) {}
  }

  function money(cents) {
    try {
      if (window.Shopify && Shopify.formatMoney) {
        return Shopify.formatMoney(cents, (window.theme && theme.moneyFormat) || undefined);
      }
    } catch (e) {}
    var value = (Number(cents) / 100).toFixed(2);
    return '₹' + value;
  }

  /** INR display for oil pack totals (₹699, ₹1,199) — strips trailing .00 */
  function moneyPackDisplay(cents) {
    try {
      if (window.Shopify && Shopify.formatMoney) {
        var formatted = Shopify.formatMoney(cents, (window.theme && theme.moneyFormat) || undefined);
        if (formatted) return String(formatted).replace(/\.00(?=\D*$)/, '');
      }
    } catch (e) {}
    var rupees = Math.round(Number(cents) / 100);
    var grouped;
    try {
      grouped = rupees.toLocaleString('en-IN');
    } catch (e2) {
      grouped = String(rupees);
    }
    return '₹' + grouped;
  }

  function qtyInputs() {
    return Array.prototype.slice.call(document.querySelectorAll('input[name="quantity"]'));
  }

  function setQty(n) {
    qtyInputs().forEach(function (input) {
      input.value = String(n);
      input.dispatchEvent(new Event('change', { bubbles: true }));
      input.dispatchEvent(new Event('input', { bubbles: true }));
    });
  }

  function variantId(root) {
    var selected =
      document.querySelector('.productView-details input[name="id"]') ||
      document.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
    if (selected && selected.value) return selected.value;
    return root ? root.dataset.variantId : null;
  }

  function qty() {
    var input = document.querySelector('input[name="quantity"]');
    var value = input ? parseInt(input.value, 10) : 1;
    return Number.isFinite(value) && value > 0 ? value : 1;
  }

  function isRootOos(root) {
    return !!(root && root.getAttribute('data-available') === 'false');
  }

  /** True OOS only — never treat temporary ATC busy / native form locks as sold out */
  function markOos(buttons, oos) {
    buttons.forEach(function (btn) {
      if (!btn) return;
      btn.dataset.wasDisabled = oos ? 'true' : 'false';
      if (oos) {
        btn.disabled = true;
        btn.setAttribute('aria-disabled', 'true');
      } else if (btn.dataset.busy !== '1') {
        btn.disabled = false;
        btn.removeAttribute('aria-disabled');
        btn.style.opacity = '';
      }
    });
  }

  function setBusy(buttons, busy) {
    buttons.forEach(function (btn) {
      if (!btn) return;
      if (busy) {
        btn.dataset.busy = '1';
        btn.disabled = true;
        btn.style.opacity = '0.7';
      } else {
        btn.dataset.busy = '';
        btn.style.opacity = '';
        btn.disabled = btn.dataset.wasDisabled === 'true';
        if (!btn.disabled) btn.removeAttribute('aria-disabled');
      }
    });
  }

  /**
   * After ATC the theme native #product-add-to-cart (inside a hidden/inert shell)
   * can stay disabled from product-form / inventory UI. That used to soft-lock our
   * sticky + main CTAs. Re-enable everything that is still in stock.
   */
  function ensurePdpCtasEnabled() {
    document.querySelectorAll('[data-arthcart-sticky-cta], [data-arthcart-main-cta]').forEach(function (root) {
      var oos = isRootOos(root);
      var btns = root.querySelectorAll(
        '[data-arthcart-sticky-atc], [data-arthcart-sticky-buy], [data-arthcart-main-atc], [data-arthcart-main-buy]'
      );
      markOos(btns, oos);
      if (!oos) {
        btns.forEach(function (btn) {
          btn.dataset.busy = '';
          btn.disabled = false;
          btn.style.opacity = '';
          btn.removeAttribute('aria-disabled');
        });
      }
    });

    /* Pack-of qty stickers/controls must stay clickable after ATC */
    document.querySelectorAll('[data-arthcart-qty-card]').forEach(function (card) {
      card.disabled = false;
      card.classList.remove('is-disabled');
      card.removeAttribute('aria-disabled');
    });

    var nativeAtc = document.querySelector('#product-add-to-cart');
    var anyInStock = document.querySelector(
      '[data-arthcart-sticky-cta][data-available="true"], [data-arthcart-main-cta][data-available="true"]'
    );
    if (nativeAtc && anyInStock) {
      nativeAtc.removeAttribute('disabled');
      nativeAtc.classList.remove('loading', 'is-loading');
    }
  }

  function openCartDrawer() {
    if (typeof window.arthcartOpenCartDrawer === 'function') {
      window.arthcartOpenCartDrawer();
      return;
    }
    document.body.classList.add('cart-sidebar-show');
    if (window.Shopify && typeof window.Shopify.getCart === 'function' && window.halo && typeof window.halo.updateSidebarCart === 'function') {
      window.Shopify.getCart(function (cart) {
        window.halo.updateSidebarCart(cart);
      });
    }
  }

  function refreshCartAfterAdd() {
    try {
      if (window.Shopify && typeof window.Shopify.getCart === 'function') {
        window.Shopify.getCart(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (el) {
            el.textContent = String((cart && cart.item_count) || 0);
          });
          if (window.jQuery && window.halo && typeof window.halo.updateSidebarCart === 'function') {
            window.halo.updateSidebarCart(cart);
          }
        });
      }
    } catch (e) {}
  }

  function addToCart(id, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: [{ id: Number(id), quantity: quantity }] })
    }).then(function (res) {
      if (!res.ok) {
        return res.json().then(function (err) {
          throw new Error((err && (err.description || err.message)) || 'Could not add to cart');
        });
      }
      return res.json();
    });
  }

  /**
   * Razorpay Magic Checkout (magic-shopify.js) Buy Now bridge.
   * Magic listens on document capture for `.rzp-magic-btn__buy-product` and
   * `magic-checkout-btn[page-type="product"]`. When present it opens Magic OTP/
   * address/pay instead of plain Shopify checkout. ATC is untouched.
   */
  function normalizeMagicCartPayload(data) {
    if (data && Array.isArray(data.items)) return data;
    if (Array.isArray(data)) return { items: data };
    if (data) return { items: [data] };
    return { items: [] };
  }

  function installMagicBuyNowBridge() {
    window.customMagicAddToCart = function () {
      var root =
        document.querySelector('[data-arthcart-main-cta]') ||
        document.querySelector('[data-arthcart-sticky-cta]');
      var id = variantId(root);
      if (!id) return Promise.reject(new Error('Missing variant'));
      var quantity = selectedPackQty();
      setQty(quantity);
      return addToCart(id, quantity).then(normalizeMagicCartPayload);
    };
  }

  function findMagicBuyTrigger(exceptEl) {
    var nodes = document.querySelectorAll(
      'magic-checkout-btn[page-type="product"], ' +
        '.shopify-payment-button__button--unbranded:not(.shopify-payment-button__button--hidden), ' +
        '.rzp-magic-btn__buy-product'
    );
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (!el || el === exceptEl) continue;
      if (el.matches('[data-arthcart-main-buy], [data-arthcart-sticky-buy]')) continue;
      return el;
    }
    return null;
  }

  function magicScriptPresent() {
    return !!(
      document.getElementById('RazorpayMagicCheckoutConfig') ||
      document.querySelector('script[src*="magic-shopify.js"]') ||
      document.querySelector('magic-checkout-btn')
    );
  }

  function bindCtaGroup(root, atcSel, buySel) {
    if (!root) return;
    var atcBtn = root.querySelector(atcSel);
    var buyBtn = root.querySelector(buySel);
    var buttons = [atcBtn, buyBtn];
    var inFlight = false;

    /* Snapshot true OOS from liquid only — do not latch temporary disabled */
    markOos(buttons, isRootOos(root));

    if (atcBtn) {
      atcBtn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (inFlight || isRootOos(root)) return;
        var id = variantId(root);
        if (!id) return;

        /*
          Do NOT click #product-add-to-cart: it lives in a hidden (previously inert)
          shell; Halo/product-form disable it after one add and that soft-locked
          sticky + main CTAs. Use cart/add.js and open our drawer instead.
        */
        inFlight = true;
        setBusy(buttons, true);
        /* Prefer active pack card so sticky ATC matches Pack of N selection */
        var packQty = selectedPackQty();
        addToCart(id, packQty)
          .then(function () {
            mpTrack('product_added_to_cart', {
              variant_id: id,
              quantity: packQty,
              cta_location: atcSel.indexOf('sticky') >= 0 ? 'sticky' : 'main'
            });
            refreshCartAfterAdd();
            openCartDrawer();
          })
          .catch(function (err) {
            window.alert(err.message || 'Could not add to cart');
          })
          .finally(function () {
            inFlight = false;
            setBusy(buttons, false);
            ensurePdpCtasEnabled();
          });
      });
    }

    if (buyBtn) {
      /*
        Primary path: Magic capture handler on `.rzp-magic-btn__buy-product`
        (class on this button) runs first and opens Magic Checkout. This
        bubble-phase handler is only the fallback when Magic did not intercept.
      */
      buyBtn.addEventListener('click', function (event) {
        if (inFlight || isRootOos(root)) {
          event.preventDefault();
          event.stopPropagation();
          return;
        }

        var packQty = selectedPackQty();
        setQty(packQty);
        mpTrack('buy_now_clicked', {
          variant_id: variantId(root),
          quantity: packQty,
          cta_location: buySel.indexOf('sticky') >= 0 ? 'sticky' : 'main'
        });

        /* If Magic already handled in capture, a modal/frame usually exists */
        if (
          document.querySelector('.razorpay-container, .razorpay-checkout-frame, magic-checkout-btn[page-type="product"]') &&
          magicScriptPresent() &&
          event.defaultPrevented
        ) {
          ensurePdpCtasEnabled();
          return;
        }

        var magicTrigger = findMagicBuyTrigger(buyBtn);
        if (magicTrigger) {
          event.preventDefault();
          event.stopPropagation();
          inFlight = true;
          setBusy(buttons, true);
          try {
            magicTrigger.click();
          } catch (e) {}
          setTimeout(function () {
            inFlight = false;
            setBusy(buttons, false);
            ensurePdpCtasEnabled();
          }, 1200);
          return;
        }

        /* Last resort: add line then Shopify /checkout (plain form) */
        event.preventDefault();
        event.stopPropagation();
        var id = variantId(root);
        if (!id) return;
        inFlight = true;
        setBusy(buttons, true);
        addToCart(id, packQty)
          .then(function () {
            window.location.href = '/checkout';
          })
          .catch(function (err) {
            window.alert(err.message || 'Could not start checkout');
          })
          .finally(function () {
            inFlight = false;
            setBusy(buttons, false);
            ensurePdpCtasEnabled();
          });
      });
    }
  }

  function updatePackPrices(unitPrice) {
    document.querySelectorAll('[data-arthcart-qty-card]').forEach(function (card) {
      if (card.hasAttribute('data-pack-price')) return;
      var n = parseInt(card.getAttribute('data-qty'), 10) || 1;
      var priceEl = card.querySelector('[data-arthcart-pack-price]');
      if (priceEl) priceEl.textContent = money(unitPrice * n);
    });
  }

  function selectedPackQty() {
    var active = document.querySelector('[data-arthcart-qty-card].is-active');
    if (active) {
      var n = parseInt(active.getAttribute('data-qty'), 10);
      if (Number.isFinite(n) && n > 0) return n;
    }
    return qty();
  }

  function selectedPackFixedPrice() {
    var active = document.querySelector('[data-arthcart-qty-card].is-active');
    if (!active || !active.hasAttribute('data-pack-price')) return null;
    var custom = parseInt(active.getAttribute('data-pack-price'), 10);
    if (!Number.isFinite(custom) || custom <= 0) return null;
    return custom;
  }

  /** Sticky bar shows pack total (unit × qty), compare-at × qty, and % OFF */
  function updateStickyPrice(unitPrice, unitCompare, packQty) {
    var sticky = document.querySelector('[data-arthcart-sticky-cta]');
    if (!sticky) return;

    var n = packQty || 1;
    var multiplied = (Number(unitPrice) || 0) * n;
    var custom = selectedPackFixedPrice();
    var price = custom != null ? custom : multiplied;
    var compare = (Number(unitCompare) || 0) * n;
    if (custom != null && multiplied > price) compare = Math.max(compare, multiplied);

    sticky.setAttribute('data-unit-price', String(unitPrice || 0));
    sticky.setAttribute('data-unit-compare', String(unitCompare || 0));
    sticky.setAttribute('data-pack-qty', String(n));

    var priceEl = sticky.querySelector('[data-arthcart-sticky-price]');
    if (priceEl) priceEl.textContent = custom != null ? moneyPackDisplay(price) : money(price);

    var compareEl = sticky.querySelector('[data-arthcart-sticky-compare]');
    var discountEl = sticky.querySelector('[data-arthcart-sticky-discount]');
    var showCompare = compare > price && price > 0;

    if (compareEl) {
      if (showCompare) {
        compareEl.textContent = money(compare);
        compareEl.hidden = false;
        compareEl.removeAttribute('hidden');
      } else {
        compareEl.textContent = '';
        compareEl.hidden = true;
        compareEl.setAttribute('hidden', '');
      }
    }

    if (discountEl) {
      if (showCompare) {
        var pct = Math.round(((compare - price) * 100) / compare);
        discountEl.textContent = pct + '% OFF';
        discountEl.hidden = false;
        discountEl.removeAttribute('hidden');
      } else {
        discountEl.textContent = '';
        discountEl.hidden = true;
        discountEl.setAttribute('hidden', '');
      }
    }
  }

  function syncStickyFromPack(root) {
    if (!root) root = document.querySelector('[data-arthcart-pack]');
    var sticky = document.querySelector('[data-arthcart-sticky-cta]');
    var unitPrice =
      (root && parseInt(root.getAttribute('data-unit-price'), 10)) ||
      (sticky && parseInt(sticky.getAttribute('data-unit-price'), 10)) ||
      0;
    var unitCompare =
      (root && parseInt(root.getAttribute('data-unit-compare'), 10)) ||
      (sticky && parseInt(sticky.getAttribute('data-unit-compare'), 10)) ||
      0;
    updateStickyPrice(unitPrice, unitCompare, selectedPackQty());
    updateHeadlineFromPack();
  }

  /** Oil PDP only: headline above SELECT QUANTITY follows data-pack-price */
  function updateHeadlineFromPack() {
    var custom = selectedPackFixedPrice();
    if (custom == null) return;

    var scope =
      document.querySelector('.arthcart-oil-pdp') ||
      document.querySelector('[data-product-handle="arth-hanuman-blessed-pain-relief-oil"]');
    if (!scope) return;

    var wrap = scope.querySelector('.productView-price');
    if (!wrap) return;

    var text = moneyPackDisplay(custom);
    wrap.querySelectorAll('.price__last .price-item, .price__regular .price-item--regular').forEach(function (el) {
      el.textContent = text;
    });
  }

  function bindPackSelector() {
    var root = document.querySelector('[data-arthcart-pack]');
    if (!root) return;
    var unitPrice = parseInt(root.getAttribute('data-unit-price'), 10) || 0;
    var unitCompare = parseInt(root.getAttribute('data-unit-compare'), 10) || 0;

    root.querySelectorAll('[data-arthcart-size-card]').forEach(function (card) {
      card.addEventListener('click', function () {
        if (card.disabled) return;
        root.querySelectorAll('[data-arthcart-size-card]').forEach(function (c) {
          c.classList.remove('is-active');
        });
        card.classList.add('is-active');
        unitPrice = parseInt(card.getAttribute('data-price'), 10) || unitPrice;
        unitCompare = parseInt(card.getAttribute('data-compare'), 10) || 0;
        root.setAttribute('data-unit-price', String(unitPrice));
        root.setAttribute('data-unit-compare', String(unitCompare));
        updatePackPrices(unitPrice);
        syncStickyFromPack(root);

        var variantIdValue = card.getAttribute('data-variant-id');
        var sizeAvailable = !card.disabled && !card.classList.contains('is-disabled');
        var nativeInput =
          document.querySelector('.arthcart-native-variant-hidden input[data-variant-id="' + variantIdValue + '"]') ||
          document.querySelector('.arthcart-native-variant-hidden label[data-variant-id="' + variantIdValue + '"]');
        if (nativeInput) {
          if (nativeInput.tagName === 'LABEL') {
            nativeInput.click();
          } else {
            nativeInput.checked = true;
            nativeInput.dispatchEvent(new Event('change', { bubbles: true }));
            nativeInput.click();
          }
        }

        var idInputs = document.querySelectorAll('input[name="id"]');
        idInputs.forEach(function (input) {
          input.value = variantIdValue;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
        document.querySelectorAll('[data-arthcart-sticky-cta], [data-arthcart-main-cta]').forEach(function (el) {
          el.dataset.variantId = variantIdValue;
          el.setAttribute('data-available', sizeAvailable ? 'true' : 'false');
        });
        ensurePdpCtasEnabled();
      });
    });

    root.querySelectorAll('[data-arthcart-qty-card]').forEach(function (card) {
      card.addEventListener('click', function () {
        /* Never soft-lock qty stickers after ATC */
        if (card.disabled && !card.classList.contains('is-disabled')) {
          card.disabled = false;
        }
        root.querySelectorAll('[data-arthcart-qty-card]').forEach(function (c) {
          c.classList.remove('is-active');
        });
        card.classList.add('is-active');
        var packQty = parseInt(card.getAttribute('data-qty'), 10) || 1;
        setQty(packQty);
        syncStickyFromPack(root);
      });
    });

    updatePackPrices(unitPrice);
    setQty(1);
    syncStickyFromPack(root);
  }

  function bindTestimonials() {
    var root = document.querySelector('[data-arthcart-testimonials]');
    if (!root) return;
    var track = root.querySelector('[data-arthcart-testimonial-track]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('.arthcart-testimonials__card'));
    var dotsWrap = root.querySelector('[data-arthcart-testimonial-dots]');
    var prev = root.querySelector('[data-arthcart-testimonial-prev]');
    var next = root.querySelector('[data-arthcart-testimonial-next]');
    if (!track || !cards.length) return;
    var index = 0;

    cards.forEach(function (_, i) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'arthcart-testimonials__dot' + (i === 0 ? ' is-active' : '');
      dot.setAttribute('aria-label', 'Go to review ' + (i + 1));
      dot.addEventListener('click', function () {
        go(i);
      });
      dotsWrap.appendChild(dot);
    });

    function go(i) {
      index = (i + cards.length) % cards.length;
      track.style.transform = 'translateX(' + -index * 100 + '%)';
      Array.prototype.forEach.call(dotsWrap.children, function (dot, di) {
        dot.classList.toggle('is-active', di === index);
      });
    }

    if (prev) prev.addEventListener('click', function () { go(index - 1); });
    if (next) next.addEventListener('click', function () { go(index + 1); });
    setInterval(function () { go(index + 1); }, 4500);
  }

  function bindPincode() {
    var form = document.querySelector('[data-arthcart-pincode-form]');
    var result = document.querySelector('[data-arthcart-pincode-result]');
    if (!form || !result) return;
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var input = form.querySelector('input[name="pincode"]');
      var pin = input && input.value ? input.value.trim() : '';
      result.hidden = false;
      if (!/^\d{6}$/.test(pin)) {
        result.textContent = 'Please enter a valid 6-digit pincode.';
        return;
      }
      result.textContent = 'Delivery available to ' + pin + ' in about 5–7 days.';
    });
  }

  function stabilizeGallery() {
    var nav = document.querySelector('[data-image-gallery-main]');
    if (!nav) return;
    var apply = function () {
      nav.querySelectorAll('.productView-img-container').forEach(function (el) {
        el.style.paddingBottom = '100%';
      });
    };
    apply();
    setTimeout(apply, 400);
  }

  function enhanceAboutIcons() {
    var listItems = document.querySelectorAll('.arthcart-about__body li');
    if (!listItems.length) return;

    var iconMap = [
      { test: /vedic/i, svg: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="12" r="8.5" stroke="currentColor" stroke-width="1.6"/><path d="M12 7.5v9M8.5 12h7" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>' },
      { test: /saint/i, svg: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="8" r="3.2" stroke="currentColor" stroke-width="1.6"/><path d="M5.5 19c1.6-3.2 4-4.8 6.5-4.8S17 15.8 18.5 19" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>' },
      { test: /hand\s*made|handmade/i, svg: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M8 11V7.5a1.5 1.5 0 0 1 3 0V11M11 10.5V6.8a1.5 1.5 0 0 1 3 0V11M14 10.2V7.6a1.5 1.5 0 0 1 3 0V14c0 3-2 5-5 5H11c-2.8 0-4.5-1.7-5.5-3.5L4 13.2a1.3 1.3 0 0 1 2.2-1.4L7 13" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>' },
      { test: /natural herb|herbs/i, svg: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 20V10M12 10c0-4 4-6 8-6-1 5-4 7-8 6Zm0 0c0-4-4-6-8-6 1 5 4 7 8 6Z" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>' },
      { test: /adulteration|unblemished|purity/i, svg: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="12" r="8.5" stroke="currentColor" stroke-width="1.6"/><path d="M8 8l8 8M16 8l-8 8" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>' },
      { test: /fragrance|perfume|artificial/i, svg: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M9 10h6v8a3 3 0 0 1-6 0v-8Z" stroke="currentColor" stroke-width="1.6"/><path d="M10 10V7.5A2 2 0 0 1 14 7v3M12 4v2" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>' },
      { test: /rose/i, svg: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 13c3 0 5-2.2 5-4.2S14.8 6 12 8c-2.8-2-5-.8-5 1.8S9 13 12 13Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/><path d="M12 13c0 3-2 5.5-5 7M12 13c0 3 2 5.5 5 7" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>' },
      { test: /handpicked|states of india|india|100\s*%\s*natural|natural herbs/i, svg: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 21s6-5.2 6-10a6 6 0 1 0-12 0c0 4.8 6 10 6 10Z" stroke="currentColor" stroke-width="1.6"/><circle cx="12" cy="11" r="2.2" stroke="currentColor" stroke-width="1.6"/></svg>' }
    ];
    var fallback = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="12" r="4.5" fill="currentColor"/></svg>';

    listItems.forEach(function (li) {
      if (li.querySelector('.arthcart-about__icon')) return;
      var text = (li.textContent || '').trim();
      var svg = fallback;
      for (var i = 0; i < iconMap.length; i++) {
        if (iconMap[i].test.test(text)) {
          svg = iconMap[i].svg;
          break;
        }
      }
      var icon = document.createElement('span');
      icon.className = 'arthcart-about__icon';
      icon.innerHTML = svg;
      var label = document.createElement('span');
      label.className = 'arthcart-about__text';
      while (li.firstChild) label.appendChild(li.firstChild);
      li.appendChild(icon);
      li.appendChild(label);
    });
  }

  function styleRelatedAddButtons() {
    var root =
      document.querySelector('[id*="product-recommendations"]') ||
      document.querySelector('.halo-recommendations-block');
    if (!root) return;

    var bagIcon =
      '<svg class="arthcart-related-add__icon" viewBox="0 0 24 24" width="14" height="14" aria-hidden="true" focusable="false"><path fill="currentColor" d="M7.5 7V6a4.5 4.5 0 0 1 9 0v1h2.25A1.75 1.75 0 0 1 20.5 8.75v10.5A1.75 1.75 0 0 1 18.75 21H5.25A1.75 1.75 0 0 1 3.5 19.25V8.75A1.75 1.75 0 0 1 5.25 7H7.5Zm1.5 0h6V6a3 3 0 0 0-6 0v1Zm-3.25 1.5a.25.25 0 0 0-.25.25v10.5c0 .138.112.25.25.25h13.5a.25.25 0 0 0 .25-.25V8.75a.25.25 0 0 0-.25-.25H5.25Z"/></svg>';

    root.querySelectorAll('.product-item').forEach(function (item) {
      /* Always strip home Add — Task 81 single Add only */
      item.querySelectorAll('.arthcart-home-add, .arthcart-home-buy-row .arthcart-home-add').forEach(function (dup) {
        dup.remove();
      });

      if (item.dataset.arthcartRelatedAdd === '1') {
        if (item.querySelectorAll('.arthcart-related-add').length > 1) {
          item.querySelectorAll('.arthcart-related-add').forEach(function (b, i) {
            if (i > 0) b.remove();
          });
        }
        return;
      }
      if (item.classList.contains('product-item--loadingNoInfo')) return;
      if (item.querySelector('.animated-loading') && !item.querySelector('.card-price .price')) return;

      var price = item.querySelector('.card-price');
      if (!price) return;

      item.querySelectorAll('.arthcart-home-add, .arthcart-related-add').forEach(function (dup) {
        dup.remove();
      });

      var variantInput = item.querySelector('form input[name="id"]');
      var variantId = variantInput && variantInput.value ? variantInput.value : '';

      if (!variantId && item.getAttribute('data-json-product')) {
        try {
          var raw = item.getAttribute('data-json-product');
          var json;
          try {
            json = JSON.parse(raw);
          } catch (parseErr) {
            var ta = document.createElement('textarea');
            ta.innerHTML = raw;
            json = JSON.parse(ta.value);
          }
          if (json && json.variants && json.variants.length) {
            var available = json.variants.find(function (v) { return v.available; }) || json.variants[0];
            variantId = String(available.id);
          }
        } catch (e) {}
      }

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'arthcart-related-add';
      btn.setAttribute('aria-label', 'Add to cart');
      btn.innerHTML = bagIcon + '<span>Add</span>';

      btn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (btn.disabled) return;
        if (!variantId) return;

        btn.disabled = true;
        var prev = btn.innerHTML;
        btn.innerHTML = bagIcon + '<span>…</span>';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: Number(variantId), quantity: 1 })
        })
          .then(function (res) {
            if (!res.ok) throw new Error('add failed');
            return res.json();
          })
          .then(function () {
            btn.innerHTML = bagIcon + '<span>Added</span>';
            openCartDrawer();
            setTimeout(function () {
              btn.innerHTML = prev;
              btn.disabled = false;
            }, 900);
          })
          .catch(function () {
            btn.innerHTML = prev;
            btn.disabled = false;
          });
      });

      item.querySelectorAll('.card-action, .card-action__group').forEach(function (action) {
        action.classList.add('arthcart-related-action-hidden');
        action.style.setProperty('display', 'none', 'important');
      });

      /* Use same buy-row pattern as home — no overlap */
      var parent = price.parentNode;
      var row = parent && parent.classList && parent.classList.contains('arthcart-related-buy-row')
        ? parent
        : null;
      if (!row) {
        row = document.createElement('div');
        row.className = 'arthcart-related-buy-row';
        if (parent) {
          parent.insertBefore(row, price);
          row.appendChild(price);
        }
      }
      price.classList.add('arthcart-related-price-row');
      row.appendChild(btn);
      item.classList.add('is-arthcart-related');
      item.dataset.arthcartRelatedAdd = '1';
      item.dataset.arthcartHomeAdd = '1';
    });
  }

  function observeRelatedProducts() {
    styleRelatedAddButtons();
    var host =
      document.querySelector('[id*="product-recommendations"]') ||
      document.querySelector('.halo-recommendations-block');
    if (!host || host.dataset.arthcartRelatedObs === '1') return;
    host.dataset.arthcartRelatedObs = '1';
    var obs = new MutationObserver(function () {
      if (host._arthcartRelT) clearTimeout(host._arthcartRelT);
      host._arthcartRelT = setTimeout(styleRelatedAddButtons, 200);
    });
    obs.observe(host, { childList: true, subtree: true });
  }

  /** Task 54 — Handpicked / policies icons: slow auto-advance carousel */
  function initPoliciesAutoCarousel() {
    var row =
      document.querySelector('.policies-block.arthcart-benefit-slider .halo-row') ||
      document.querySelector('.policies-block .halo-row.slider');
    if (!row || row.dataset.arthcartPoliciesAuto === '1') return;
    var items = row.querySelectorAll('.halo-item');
    if (items.length < 2) return;

    row.dataset.arthcartPoliciesAuto = '1';

    var index = 0;
    var paused = false;
    var timer = null;

    function goTo(i) {
      var item = items[i];
      if (!item) return;
      row.scrollTo({ left: item.offsetLeft, behavior: 'smooth' });
    }

    function tick() {
      if (paused) return;
      if (window.matchMedia && !window.matchMedia('(max-width: 989px)').matches) return;
      index = (index + 1) % items.length;
      goTo(index);
    }

    function start() {
      if (timer) clearInterval(timer);
      timer = setInterval(tick, 3800);
    }

    row.addEventListener('touchstart', function () { paused = true; }, { passive: true });
    row.addEventListener('touchend', function () {
      paused = false;
      setTimeout(start, 2500);
    }, { passive: true });
    row.addEventListener('mouseenter', function () { paused = true; });
    row.addEventListener('mouseleave', function () { paused = false; });

    if (window.matchMedia('(max-width: 989px)').matches) {
      goTo(0);
      start();
    }

    window.addEventListener('resize', function () {
      if (window.matchMedia('(max-width: 989px)').matches) start();
      else if (timer) clearInterval(timer);
    });
  }

  function watchCartCloseForCtaUnlock() {
    if (document.documentElement.dataset.arthcartCtaUnlockObs === '1') return;
    document.documentElement.dataset.arthcartCtaUnlockObs = '1';
    var wasOpen = document.body.classList.contains('cart-sidebar-show');
    new MutationObserver(function () {
      var isOpen = document.body.classList.contains('cart-sidebar-show');
      if (wasOpen && !isOpen) ensurePdpCtasEnabled();
      wasOpen = isOpen;
    }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }

  function init() {
    installMagicBuyNowBridge();
    bindCtaGroup(document.querySelector('[data-arthcart-sticky-cta]'), '[data-arthcart-sticky-atc]', '[data-arthcart-sticky-buy]');
    bindCtaGroup(document.querySelector('[data-arthcart-main-cta]'), '[data-arthcart-main-atc]', '[data-arthcart-main-buy]');
    bindPackSelector();
    bindTestimonials();
    bindPincode();
    stabilizeGallery();
    enhanceAboutIcons();
    observeRelatedProducts();
    initPoliciesAutoCarousel();
    ensurePdpCtasEnabled();
    watchCartCloseForCtaUnlock();
    setTimeout(styleRelatedAddButtons, 1500);
  }

  /* Install early so Magic's capture Buy Now can use pack qty immediately */
  installMagicBuyNowBridge();

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
